var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTemplateGenerator = function SvgTemplateGenerator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#CDC2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 28.5v-5.7c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C33.72 18 32.88 18 31.2 18h-6.4c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C20 20.28 20 21.12 20 22.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C22.28 38 23.12 38 24.8 38H28m2-11h-6m2 4h-2m8-8h-8m6.5 12 2 2 4.5-4.5",
    stroke: "#6F469A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#E3DEF2",
    strokeWidth: 8
  })));
};
export default SvgTemplateGenerator;